// extracted by mini-css-extract-plugin
module.exports = {"header":"CarFeatures_header__l1y_8","carFeaturesContainer":"CarFeatures_carFeaturesContainer__YBL16","fadeOutContainer":"CarFeatures_fadeOutContainer__u4eOD"};